"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
function deserializeRecord(deserializeKey, deserializeValue) {
    return function (value) {
        const object = (0, deserializeObject_1.default)(value);
        const record = Object.create(Object.prototype);
        Object.entries(object).forEach(([key, value]) => {
            record[deserializeKey(key)] = deserializeValue(value);
        });
        return record;
    };
}
exports.default = deserializeRecord;
